var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5B300",
    fillRule: "evenodd",
    d: "M11.21 9.627c.074 0 .14-.049.163-.12 0 0 .574-1.808.924-2.916.063-.2.34-.2.405 0l.926 2.916c.023.071.089.12.163.12h2.997c.207 0 .293.269.126.393l-2.427 1.803a.179.179 0 00-.061.195l.927 2.916c.064.2-.16.368-.327.244l-2.427-1.805a.171.171 0 00-.2 0l-2.425 1.805c-.167.123-.39-.043-.327-.244.35-1.106.926-2.916.926-2.916a.179.179 0 00-.062-.195L8.084 10.02c-.167-.124-.08-.393.125-.393h3zM12.5 24a.51.51 0 01-.355-.147l-1.678-1.646C4.543 16.848 0 12.335 0 7.285 0 3.2 3.12 0 7.106 0c2.737 0 4.146 1.387 5.394 2.864C13.747 1.387 15.157 0 17.893 0 21.878 0 25 3.2 25 7.285c0 5.05-4.544 9.563-10.482 14.936l-1.663 1.632A.506.506 0 0112.5 24"
  })));
}
SvgIconAdd.displayName = 'IconAdd';
export default SvgIconAdd;